<script>
import CreateAddForm from '../list/create_components.vue'
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'UpdateModal',
    components:{
        CreateAddForm 
    },
    data() {
        return {
            submitted: false,
            size:'md',
            vendor:'',
            formInitialData: {
                fname:'',
                lname:'',
                username:'',
                bilgi:false
            },
        };
    }, 
    computed:{
        ...mapState('userDetail', ['userDetail']),
        ...mapGetters('authfack',['settings']),
        modalTitle(){ return  this.userDetail.type ? "Bilgi Güncelle" : "Bilgiler"},
        temporarily(){
            return this.formInitialData.temporarily?.hasOwnProperty('id') ? this.formInitialData.temporarily.newtariffexplaine + ` ( ${this.formInitialData.temporarily.expiredate} ) ` : null
        }
    },
    watch:{
        userDetail:{
            handler(newv){
                this.size = newv.bilgi ? 'lg' : 'md'
                this.formInitialData= { ...newv }
                if(newv.mac){
                    this.$http.get(`/services/get-vendors/${newv.mac}`)
                    .then(response => {
                        this.vendor = response.data.vendor
                    })
                }
            },
            deep:true
        },
    },
    methods: {
        onlyAdmin() {
            const userdata = JSON.parse(localStorage.getItem('userdata'))
            return userdata.role_name == 'admin'
        },
        gunFarkiHesapla(hedefTarih,ikinciTarih = null) {
            var suAnkiTarih = ikinciTarih ? new Date(ikinciTarih) : new Date();
            var hedefTarihObj = new Date(hedefTarih);
            var gunFarki = Math.floor(( suAnkiTarih  - hedefTarihObj) / (1000 * 60 * 60 * 24));
            return gunFarki;
        },
        gunEkle(hedefTarih) {
            var suAnkiTarih = new Date();
            var hedefTarihObj = new Date(hedefTarih);
            var gunFarki = Math.floor((  hedefTarihObj - suAnkiTarih ) / (1000 * 60 * 60 * 24));
            return gunFarki;
        },
        tarihCikar(baslangicTarihi,ayCikart) {
            if(!baslangicTarihi && !ayCikart) return
            // Tarih ve saat bilgisini ayır
            const tarihBilgisi = baslangicTarihi.split(' '); // Boşluk karakterine göre ayır

            // Tarih ve saat ayrı ayrı işlemlere tabi tut
            const tarih = tarihBilgisi[0];
            const saat = tarihBilgisi[1];

            // Tarih ve saat bilgisini ayrı ayrı parçala
            const tarihParcalari = tarih.split('-');
            const saatParcalari = saat.split(':');

            // Yıl, ay, gün, saat, dakika ve saniye değerlerini al
            const yil = parseInt(tarihParcalari[0]);
            const ay = parseInt(tarihParcalari[1]);
            const gun = parseInt(tarihParcalari[2]);
            const saat2 = parseInt(saatParcalari[0]);
            const dakika = parseInt(saatParcalari[1]);
            const saniye = parseInt(saatParcalari[2]);

            // Belirli bir ayı çıkart
            const yeniTarih = new Date(yil, ay - 1, gun, saat2, dakika, saniye);
            yeniTarih.setMonth(yeniTarih.getMonth() - ayCikart);
            const tarihg =  yeniTarih.toISOString().replace('T', ' ').replace('Z', '').replace('.000', '');


            const gunFarki = this.gunFarkiHesapla(tarihg,this.formInitialData.expiredate);
            const bolunmus = parseFloat(this.formInitialData.price) / parseFloat(gunFarki)
            const yuvarlanmis = parseFloat(this.ozelYuvarla(bolunmus))
            const kalanGun = parseFloat(this.gunEkle(this.formInitialData.expiredate));
            const sonuc = kalanGun * yuvarlanmis

            
            return sonuc > 0 ? sonuc.toFixed(2) + ' TL' : '';
        },
        ozelYuvarla(sayi) {
            // İstenen sonucu elde etmek için işlem yap
            const hassaslik = 2; // Yuvarlama hassasiyeti (örneğin 2 ondalık basamak)
            const katsayi = Math.pow(10, hassaslik);
            const yuvarlanmisSayi = Math.round(sayi * katsayi) / katsayi;
            return yuvarlanmisSayi.toFixed(hassaslik); // Sonucu istenen hassasiyette bir string olarak döndür
        },
        close(){
            this.$parent.$bvModal.hide('update_modal')
        }
    },
};
</script>
 
<template>
<b-modal id="update_modal" :title="modalTitle"  no-close-on-backdrop hide-footer>
    <div class="row" v-if="formInitialData.hasOwnProperty('bilgi') && !formInitialData.bilgi">
        <div class="col-md-12">
                <div class="alert alert-warning">
                {{ formInitialData.fname }}
                {{ formInitialData.lname }}
                <br>
                {{ formInitialData.username}}
            </div>
        </div>
    </div>  
    <CreateAddForm  v-if="!formInitialData.hasOwnProperty('bilgi') && !formInitialData.bilgi" :formData="formInitialData" @close="close" />
    <div class="row" v-else>
        <div class="table-responsive">  
            <table class="table table-sm">
                <tbody>
                    <tr>
                        <th>İsim Soyisim</th>
                        <td>{{ formInitialData.fname }} {{ formInitialData.lname }}</td>
                    </tr> 
                    <tr>
                        <th>Kullanıcı Adı</th>
                        <td>{{ formInitialData.username }}</td>
                    </tr>
                    <tr>
                        <th>Şifre</th>
                        <td>{{ formInitialData.password }}</td>
                    </tr>
                    <tr>
                        <th>Bitiş Tarihi</th>
                        <td>{{ formInitialData.expiredate_format }}</td>
                    </tr>
                    <tr>
                        <th>Kalan Gün / Ederi</th>
                        <td>{{ gunEkle(formInitialData.expiredate) }} Gün / {{ tarihCikar(formInitialData.expiredate, formInitialData.time ) }}</td>
                    </tr>
                    <tr>
                        <th>Bayi</th>
                        <td>{{ formInitialData.user_name }}</td>
                    </tr>
                    <tr>
                        <th>Tarife Tipi</th>
                        <td>{{ formInitialData.tariff_type }}</td>
                    </tr>
                    <tr>
                        <th>Tarife</th>
                        <td>{{ formInitialData.tariff_name }}</td>
                    </tr>
                    <tr v-if="temporarily">
                        <th>Geçici Hız</th>
                        <td>{{ temporarily }}</td>
                    </tr>
                    <tr>
                        <th>Telefon1</th>
                        <td><a :href="`tel:${formInitialData.phonenumber}`">{{ formInitialData.phonenumber }}</a></td>
                    </tr>
                    <tr>
                        <th>Telefon2</th>
                        <td><a target="_blank" :href="`https://wa.me/${formInitialData.phonenumber2}`" >{{formInitialData.phonenumber2}}</a></td>
                    </tr>
                    <tr>
                        <th>Adres</th>
                        <td>{{ formInitialData.address }}</td>
                    </tr>
                    <tr>
                        <th>İlçe / Bölge</th>
                        <td>{{ formInitialData.province }} / {{ formInitialData.township }}</td>
                    </tr>
                     <tr>
                        <th>Koordinat</th>
                        <td>{{ formInitialData.coordinate }}</td>
                    </tr>
                    <tr>
                        <th>E-mail</th>
                        <td>{{ formInitialData.email }}</td>
                    </tr>
                    <tr v-if="onlyAdmin()">
                        <th>İp</th>
                        <td>{{ formInitialData.static_ip }}
                            <span v-if="settings.winbox">
                                <a :href="`winbox://${formInitialData.static_ip}/admin/teq1199qet!!`">
                                    <button class="btn btn-sm btn-info" style="margin-left:15px">Winbox</button>
                                </a>
                                <a target="_blank" :href="`http://${formInitialData.static_ip}:8888`">
                                    <button class="btn btn-sm btn-warning" style="margin-left:15px">Modem</button>
                                </a>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="onlyAdmin()">
                        <th>MAC</th>
                        <td>{{ formInitialData.mac }}   <br/> {{ vendor }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</b-modal>
</template>